import type { InteractiveResponseAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import SubActivityView from '../../sub-activity/sub-activity-view';
import {
  InteractiveCategoriseAttempt,
  ViewProps,
} from './interactive-response-categorise.constants';
import InteractiveResponseCategorise from './play/interactive-response-categorise';
import { ClassroomAnswerInstruction } from 'approot/activity-builder/classroom/classroom-answer.style';
import {
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import InteractiveResponseImageZoom from '../shared/interactive-response-image-zoom';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { useInteractiveImages } from '../shared/interactive-response-shared.hooks';
import { InteractiveAudioProvider } from '../shared/interactive-audio.context';

const InteractiveResponseCategoriseLargeView = ({
  isPlaying,
  finishGame,
  setCloseModalCallback,
  showAnswer,
  ...props
}: ViewProps & {
  isPlaying: boolean;
  attemptAnswers?: InteractiveResponseAnswerFragment;
  onAnswerAttempt: InteractiveCategoriseAttempt;
  finishGame: () => void;
  setCloseModalCallback: (callback: Function | undefined) => void;
  showAnswer: boolean;
}) => {
  const { isVisible, openModal, closeModal } = useSimpleModalState();

  const {
    currentItem,
    isNextDisabled,
    isPrevDisabled,
    onNextImage,
    onPrevImage,
    onImageClick,
    reset: resetImages,
  } = useInteractiveImages();

  return (
    <InteractiveAudioProvider>
      <ActivitySheetInnerContent id="content">
        <ActivitySheetInnerMax>
          <ClassroomAnswerInstruction
            style={{
              display: isVisible ? 'none' : '',
            }}
          >
            <SubActivityView
              withTTSButton
              componentId={props.id}
              componentType={props.type}
              subActivityDetails={props.subActivityProperties}
            >
              <InteractiveResponseCategorise
                {...props}
                onExpandImage={(id, dragItems) => {
                  setCloseModalCallback(() => closeModal());
                  onImageClick(id, dragItems);
                  openModal();
                }}
                showAnswer={showAnswer}
              />
            </SubActivityView>
          </ClassroomAnswerInstruction>
        </ActivitySheetInnerMax>
      </ActivitySheetInnerContent>

      {isVisible && currentItem ? (
        <InteractiveResponseImageZoom
          itemToPreview={currentItem}
          isNextDisabled={isNextDisabled}
          isPrevDisabled={isPrevDisabled}
          variant={props.properties.interactiveResponseCategorise.variant}
          onNext={onNextImage}
          onPrevious={onPrevImage}
          onBackClick={() => {
            setCloseModalCallback(undefined);
            resetImages();
            closeModal();
          }}
        />
      ) : null}
    </InteractiveAudioProvider>
  );
};

export default InteractiveResponseCategoriseLargeView;
